<div>
<nx-pageTitle-box
  [label]="timeEntryCategory?.name"
  [bcRootLvlLabel]="'core.settings.label'"
  [bcRootLvlPath]="'/settings'"
  [bcRootLvl1Label]="'core.timeEntryCategoryList.pageTitleBox.label'"
  [bcRootLvl1Path]="'/settings/timeEntryCategories'"
  [icon]="'icon-time'"
  [iconToolTip]="'core.timeEntryCategoryList.pageTitleBox.iconToolTip'">
  <ng-template nxTemplate="tag">
    <p-tag
      [value]="timeEntryCategory?.enabled ? 'aktiv' : 'inaktiv'"
      [severity]="timeEntryCategory?.enabled ? 'success' : 'danger'">
    </p-tag>
  </ng-template>
  <ng-template nxTemplate="end">
    <!-- place holder für löschen -->
    <!-- <nx-default-button
      *ngIf="user?.enabled"
      (click)="suspendUser()"
      [tooltip]="'Nutzer deaktivieren'"
      [label]="'Nutzer deaktivieren'"
      [style]="'light'">
    </nx-default-button> -->
  </ng-template>
</nx-pageTitle-box>


  <p-tabView [scrollable]="true">
    <p-tabPanel header="Allgemein">
      <div class="flex flex-row gap-4 mt-2">
      <div
        class="basis-1/2">
        <nx-headline-box
          [label]="'Zeiterfasungskategorie'">
          <ng-template nxTemplate="end">
            <nx-default-button
              (click)="editTimeEntryCategory()"
              [tooltip]="'Kategorie bearbeiten'"
              [icon]="'icon-edit'"
              [style]="'light'">
            </nx-default-button>
          </ng-template>
        </nx-headline-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Name'">
          {{timeEntryCategory?.name}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Externe ID'">
          {{timeEntryCategory?.externalId}}
        </nx-default-box>
        <nx-default-box
          class="bg-white border-b border-gray"
          [label]="'Farbe'">
          <div class="flex items-center gap-2">
            <div class="w-2 h-2 rounded-full flex-shrink-0" [style.background-color]="timeEntryCategory?.color || '#2196f3'"></div>
            {{timeEntryCategory?.color || '#2196f3'}}
          </div>
        </nx-default-box>
      </div>
      <div
        class="basis-1/2">
        
      </div>
    </div>
    </p-tabPanel>
  
  </p-tabView>

